import React from 'react';
import { Disclosure } from '@headlessui/react'
import { HomeIcon } from '@heroicons/react/outline'
import { useAppDispatch, useAppSelector } from '../hooks';
import { updateFeedPageSelection } from '../reducer';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const navigation = [
  { name: 'About', href: '#', key: 'about' ,current: false },
  {
    name: 'Price Feeds',
    current: false,
    key: 'prices',
    children: [
      { name: 'USD Pairs', href: '#', current: true, key: 'usd', },
      { name: 'Euro Pairs', href: '#', key: 'euro', },
      { name: 'BTC Pairs', href: '#', key: 'btc', },
      { name: 'Other Pairs', href: '#', key: 'other', },
    ],
    icon: HomeIcon,
  },
  {
    name: 'Weather Feeds',
    current: false,
    children: [
      { name: 'North America', href: '#', key: 'na', },
      { name: 'South America', href: '#', key: 'sa', },
      { name: 'Africa', href: '#', key: 'africa', },
      { name: 'Asia', href: '#', key: 'asia', },
    ],
  }
]

const secondaryNavigation = [
  { name: 'Become A Feed Provider', href: '#', current: true, key: 'joinfp', },
  { name: 'Stop Providing Feeds', href: '#' , current: false, key: 'leavefp',}
]

export default function FeedSideBar() {
  const dispatch = useAppDispatch();
  const pageSelection = useAppSelector(state => state.subscription.feedPageSelection);

  return (
    <div className="flex flex-col basis-1/4 border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto">
      <div className=" flex-grow flex flex-col">
        <nav className="mt-5 flex-1 px-2 space-y-1 bg-white" aria-label="Sidebar">
          {navigation.map((item) =>
            !item.children ? (
              <div key={item.name}>
                <a
                  onClick={() => dispatch(updateFeedPageSelection(item.key))}
                  className={classNames(
                    item.key === pageSelection
                      ? 'bg-gray-100 text-gray-900'
                      : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                    'group w-full flex items-center pl-7 pr-2 py-2 text-sm font-medium rounded-md'
                  )}
                >
                  {item.name}
                </a>
              </div>
            ) : (
              <Disclosure as="div" key={item.name} className="mt-5 space-y-1">
                {({ open }) => (
                  <>
                    <Disclosure.Button
                      className={classNames(
                        item.key === pageSelection
                          ? 'bg-gray-100 text-gray-900'
                          : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                        'group w-full flex items-center pr-2 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500'
                      )}
                    >
                      <svg
                        className={classNames(
                          open ? 'text-gray-400 rotate-90' : 'text-gray-300',
                          'mr-2 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150'
                        )}
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                      >
                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                      </svg>
                      {item.name}
                    </Disclosure.Button>
                    <Disclosure.Panel className="space-y-1">
                      {item.children.map((subItem: any) => (
                        <button
                          key={subItem.name}
                          onClick={() => dispatch(updateFeedPageSelection(subItem.key))}
                          className={`${subItem.key === pageSelection && 'bg-gray-100 text-gray-900'} group w-full flex items-center pl-10 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50`}
                        >
                          {subItem.name}
                        </button>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            )
          )}
          <div className="space-y-1">
            <h3 className="mt-10 mb-5 px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" id="projects-headline">
              Resources
            </h3>
            <div className="space-y-1" role="group" aria-labelledby="projects-headline">
              {secondaryNavigation.map((item) => (
                <a
                  key={item.name}
                  onClick={() => dispatch(updateFeedPageSelection(item.key))}
                  className={`${item.key === pageSelection && 'bg-gray-100 text-gray-900'} group flex items-center px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50`}
                >
                  <span className="truncate">{item.name}</span>
                </a>
              ))}
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}
